var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 32,
    fill: "#1D9BF0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.1436 48.8798C40.3356 48.8798 48.0956 37.1198 48.0956 26.9278C48.0956 26.5918 48.0956 26.2558 48.0796 25.9358C49.5836 24.8478 50.8956 23.4878 51.9356 21.9358C50.5596 22.5438 49.0716 22.9598 47.5036 23.1518C49.1036 22.1918 50.3196 20.6878 50.8956 18.8798C49.4076 19.7598 47.7596 20.3998 45.9996 20.7518C44.5916 19.2478 42.5916 18.3198 40.3676 18.3198C36.1116 18.3198 32.6556 21.7758 32.6556 26.0318C32.6556 26.6398 32.7196 27.2318 32.8636 27.7918C26.4476 27.4718 20.7676 24.3998 16.9596 19.7278C16.3036 20.8638 15.9196 22.1918 15.9196 23.5998C15.9196 26.2718 17.2796 28.6398 19.3596 30.0158C18.0956 29.9838 16.9116 29.6318 15.8716 29.0558C15.8716 29.0878 15.8716 29.1198 15.8716 29.1518C15.8716 32.8958 18.5276 35.9998 22.0636 36.7198C21.4236 36.8958 20.7356 36.9918 20.0316 36.9918C19.5356 36.9918 19.0556 36.9438 18.5756 36.8478C19.5516 39.9198 22.3996 42.1438 25.7756 42.2078C23.1356 44.2718 19.8076 45.5038 16.1916 45.5038C15.5676 45.5038 14.9596 45.4718 14.3516 45.3918C17.7276 47.5998 21.7916 48.8798 26.1436 48.8798Z",
    fill: "#FEFEFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.8867683aa12b93f2b9f5afa135a11033.svg";
export { ForwardRef as ReactComponent };